import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'LoginAngular.aspx',
    loadChildren: () => import('./modules/auth/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'ForgotPassword.aspx',
    loadChildren: () =>
      import('./modules/auth/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule)
  },
  {
    path: 'ResetPassword.aspx',
    loadChildren: () => import('./modules/auth/reset-password/reset-password.module').then((m) => m.ResetPasswordModule)
  },
  {
    path: 'AngularReports.aspx',
    loadChildren: () => import('./modules/streaming/reports/reports.module').then((m) => m.ReportsModule)
  },
  {
    path: 'CameraSettings.aspx',
    loadChildren: () =>
      import('./modules/settings/camera-settings/camera-settings.module').then((m) => m.CameraSettingsModule)
  },
  {
    path: 'DeviceLiveLocation.aspx',
    loadChildren: () =>
      import('./modules/dashboard/camera-realtime-map/camera-realtime-map.module').then(
        (m) => m.CameraRealtimeMapModule
      )
  },
  {
    path: 'Webrtcfeeds.aspx',
    loadChildren: () => import('./modules/streaming/webrtc-feeds/webrtc-feeds.module').then((m) => m.WebrtcFeedsModule)
  },
  {
    path: 'AngularSession.aspx',
    loadChildren: () => import('./modules/media/session/session.module').then((m) => m.SessionModule)
  },
  {
    path: 'AngularEvidence.aspx',
    loadChildren: () => import('./modules/evidence/evidence.module').then((m) => m.EvidenceModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
